'use client'

import React, { type JSX, type ReactElement } from 'react'
import { cx } from 'utils/cx'

import style from './LinkListGrid.module.scss'

export interface LinkListGridProps {
	readonly id?: string
	readonly children: ReactElement | ReactElement[]
	readonly showChildrenBorder?: boolean
	readonly linkChildrenAs?: React.ComponentType
	readonly 'data-testid'?: string
}

export function LinkListGrid({
	id,
	children,
	linkChildrenAs,
	showChildrenBorder = true,
	'data-testid': dataTestId,
}: LinkListGridProps) {
	const childrenWithProps = React.Children.map(children, (child: JSX.Element) =>
		React.cloneElement(child, {
			linkAs: child.props.linkAs ?? linkChildrenAs,
		})
	)

	return (
		<ul
			id={id}
			className={cx(style.list, showChildrenBorder ? style.border : '')}
			data-testid={dataTestId}
		>
			{childrenWithProps}
		</ul>
	)
}
